<mc-navigation-bar [title]="title">
</mc-navigation-bar>